import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    INIT_URL,
    // SIGNOUT_USER_SUCCESS,
    USER_TOKEN_SET,
    TYPE_USER_SET,
    USER_INFO_SET, SIGNOUT_USER_SUCCESS,
    TYPE_USER_HOSPITAL_SET,
    REQUEST_DELETE_ACCOUNT_SUCCESS,
    REQUEST_DELETE_ACCOUNT_ERROR
} from '../constants/ActionTypes';
import { requestGql } from 'constants/Request';
import jwtDecode from 'jwt-decode';

export const setInitUrl = url => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const userSignUp = ({ name, email, password }) => {
    if (!name) {
        return alert('Please enter name');
    }
    if (!email) {
        return alert('Please enter email');
    }
    if (!password) {
        return alert('Please enter password');
    }
    return dispatch => {
        dispatch({ type: FETCH_START });
        // axios.post('auth/register', {
        //   email: email,
        //   password: password,
        //   name: name
        // }
        // ).then(({ data }) => {
        //   console.log("data:", data);
        //   if (data.result) {
        //     localStorage.setItem("mhc", JSON.stringify(data.token.access_token));
        //     dispatch({ type: FETCH_SUCCESS });
        //     dispatch({ type: USER_TOKEN_SET, payload: data.token.access_token });
        //     dispatch({ type: USER_DATA, payload: data.user });
        //   } else {
        //     console.log("payload: data.error", data.error);
        //     dispatch({ type: FETCH_ERROR, payload: "Network Error" });
        //   }
        // }).catch(function (error) {
        //   dispatch({ type: FETCH_ERROR, payload: error.message });
        //   console.log("Error****:", error.message);
        // });
    };
};

export const userSignIn = ({ email, password }) => {
    return dispatch => {
        if (!email) {
            return alert('Please enter email');
        }
        if (!password) {
            return alert('Please enter password');
        }
        let domain = window.location.host;
        dispatch({ type: FETCH_START });
        const mutations = `
    mutation adminSignin($email: String, $password: String,$domain:String) {
      adminSignin(input: { email: $email, password: $password,domain:$domain }) {
        token
        status
        userType
        hospital_id
      }
    }
    `;
        const variables = {
            email,
            password,
            domain
        };
        requestGql(mutations, variables)
            .then(data => {
                console.log('userSignIn: ', data);
                if (data.adminSignin && data.adminSignin.token) {
                    const jwtToken = jwtDecode(data.adminSignin.token);
                    if(jwtToken.role_id === 4){
                        alert("Login fail")
                        return ;
                    }
                    if(jwtToken.role_id === 5 || jwtToken.role_id === 6){
                        console.log("is inside here role is 5")
                        dispatch({
                            type: TYPE_USER_HOSPITAL_SET,
                            payload: data.adminSignin
                        });
                    }
                    console.log("jwtToken ", jwtToken)
                    localStorage.setItem('mhc', data.adminSignin.token);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: USER_TOKEN_SET,
                        payload: data.adminSignin.token
                    });
                    dispatch({
                        type: TYPE_USER_SET,
                        payload: data.adminSignin.userType
                    });
                    
                } else {
                    // dispatch({ type: FETCH_ERROR, payload: 'Login fail' });
                    alert(data.adminSignin.status || "Login fail")
                }
            })
            .catch(function(error) {
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log('Error****:', error.message);
            });
    };
};

export const getUser = () => {
    return dispatch => {
        dispatch({ type: FETCH_START });
        let query = `query{
            adminAvatarDetail{
                name,
                image,
                userType,
                user_id,
                hospital_id,
                email
            }
        }`;
        requestGql(query)
            .then(data => {
                if (data.adminAvatarDetail) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: TYPE_USER_SET,
                        payload: data.adminAvatarDetail.userType
                    });
                    dispatch({
                        type: USER_INFO_SET,
                        payload: {
                            image: data.adminAvatarDetail.image,
                            name: data.adminAvatarDetail.name,
                            user_id: data.adminAvatarDetail.user_id,
                            email:data.adminAvatarDetail.email
                        }
                    });
                    dispatch({
                        type: TYPE_USER_HOSPITAL_SET,
                        payload: data.adminAvatarDetail
                    });
                }
            })
            .catch(function(error) {
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log('Error****:', error.message);
            });
    };
};

export const userSignOut = () => {
    return (dispatch) => {
        const query = `mutation { 
            logoutAdmin
        }`;

        requestGql(query)
            .then((data) => {
                if (data.logoutAdmin) {
                    localStorage.removeItem('mhc');
                    dispatch({
                    type: SIGNOUT_USER_SUCCESS,
                    payload: null
                });
                }
            })
            .catch(function (error) {
                console.log('Error****:', error.message);
            });
    };
};

export const userSignOutToken = () => {
    return (dispatch) => {
            localStorage.removeItem('mhc');
            dispatch({
            type: SIGNOUT_USER_SUCCESS,
            payload: null
        });
    };
};

export const requestDeleteAccount = ({ email }) => {
    return (dispatch) => {
        const query = `
            mutation requestDeleteAccount($email: String!) {
                requestDeleteAccount(input: { email: $email }) {
                    success
                    error {
                        code
                        msg
                    }
                }
            }
        `;

        const variables = {
            email
        };

        requestGql(query, variables)
            .then((data) => {
                if (data.requestDeleteAccount && data.requestDeleteAccount.success) {
                    dispatch({ type: REQUEST_DELETE_ACCOUNT_SUCCESS });
                } else {
                    dispatch({ type: REQUEST_DELETE_ACCOUNT_ERROR });
                }
            })
            .catch(function (error) {
                console.log('Error****:', error.message);
                dispatch({ type: REQUEST_DELETE_ACCOUNT_ERROR });
            });
    };
};